import { defineMessages } from 'react-intl';

export default defineMessages({
  delete: {
    id: 'app.containers.RouteAssignment.RevokePublisherShiftApplictionButton.delete',
    defaultMessage: 'Delete application from {publisherName}',
  },
  dialogTitle: {
    id: 'app.containers.RouteAssignment.RevokePublisherShiftApplictionButton.dialogTitle',
    defaultMessage: 'Should the application really be deleted?',
  },
  dialogDescription: {
    id: 'app.containers.RouteAssignment.RevokePublisherShiftApplictionButton.dialogDescription',
    defaultMessage:
      'Deleting the application will remove it permanently from this shift. To assign the publisher to this route or another route during this shift, the publisher would have to apply again.',
  },
  dialogConfirm: {
    id: 'app.containers.RouteAssignment.RevokePublisherShiftApplictionButton.dialogConfirm',
    defaultMessage: 'Yes, delete application from {publisherName}',
  },
  dialogCancel: {
    id: 'app.containers.RouteAssignment.RevokePublisherShiftApplictionButton.dialogCancel',
    defaultMessage: 'Keep application',
  },
  snackbarSuccess: {
    id: 'app.containers.RouteAssignment.RevokePublisherShiftApplictionButton.snackbarSuccess',
    defaultMessage: 'Successfully deleted application from {publisherName}',
  },
  snackbarFailure: {
    id: 'app.containers.RouteAssignment.RevokePublisherShiftApplictionButton.snackbarFailure',
    defaultMessage: "Couldn't delete application from {publisherName}",
  },
});
